import React from "react";
import DatePicker from "react-datepicker";

const ListDateInput = (props) => {
  const {
    label = "",
    name = "",
    divClassName = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      {label}
      <div className={`input-wrap ${divClassName}`}>
        <DatePicker name={name} id={props?.id ?? name} {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default ListDateInput;
